import { ItemsFiltersPanel } from '../filters/ItemsFiltersPanel'
import { ITEM_FILTER_SECTION_KEY } from '../../common/src/reducers/filtersKeys'
import type { FC, PropsWithChildren } from 'react'
import { Sections } from '../filters/ItemFiltersView.Common'
import { ItemsFiltersView } from '../filters/ItemsFiltersView'

interface IProps extends PropsWithChildren {
  headerText?: string
  onOpened?: () => void
  isOpen: boolean
  onDismiss: () => void
  [key: string]: any
}

const hideSections = [Sections.Dates, Sections.Sort, Sections.CustomFilters]

export const GlobalCalendarFiltersPanel: FC<IProps> = ({ ...rest }) => {
  return (
    <ItemsFiltersPanel onOpened={() => {}} headerText="" {...rest}>
      <ItemsFiltersView filtersType={ITEM_FILTER_SECTION_KEY.GLOBAL_CALENDAR} hideSections={hideSections} />
    </ItemsFiltersPanel>
  )
}
